import { isNumber } from './is-number';

export function isInBetween(value: unknown, start: number, end: number): boolean {
  if (!isNumber(value)) {
    return false;
  }

  return start <= value && value <= end;
}
